import { Link } from "react-router-dom";

import {
  homeItems,
  blogItems,
  pageItems,
  dashboardItems,
} from "../../data/mainMenuData";
import CategoriesMegaMenu from "./CategoriesMegaMenu";
import FlightsMegaMenu from "./FlightsMegaMenu";
import {
  isActiveParent,
  isActiveLink,
  isActiveParentChaild,
} from "../../utils/linkActiveChecker";
import { useLocation } from "react-router-dom";
import { useState } from "react";

const MainMenu = ({ style = "" }) => {
  const { pathname } = useLocation();
  const [isActiveParent, setIsActiveParent] = useState(false);

  return (
    <nav className="menu js-navList">
      <ul className={`menu__nav ${style} -is-active`}>
        <li
          className={`${
            isActiveParentChaild(homeItems, pathname) ? "current" : ""
          } menu-item-has-children`}
        >
          <Link to="/">Strona główna</Link>
          {/*<ul className="subnav">*/}
          {/*  {homeItems.map((menu, i) => (*/}
          {/*    <li*/}
          {/*      key={i}*/}
          {/*      className={*/}
          {/*        isActiveLink(menu.routePath, pathname) ? "current" : ""*/}
          {/*      }*/}
          {/*    >*/}
          {/*      <Link to={menu.routePath}>{menu.name}</Link>*/}
          {/*    </li>*/}
          {/*  ))}*/}
          {/*</ul>*/}
        </li>
        <li
          className={
            (pathname === "/flights" || pathname === "/best-flights")
              ? "menu-item-has-children -has-mega-menu current"
              : "menu-item-has-children -has-mega-menu"
          }
        >
          <Link to="/flights">
            <span className="mr-10">Loty</span>
            <i className="icon icon-chevron-sm-down" />
          </Link>
          <div className="mega" style={{ width: "260px" }}>
            <FlightsMegaMenu />
          </div>
        </li>
        {/* End flights menu item */}
        <li>
          <Link to="/best-offers">Najlepsze oferty</Link>
        </li>
        {/* End home page menu */}

        <li className={pathname === "/map" ? "current" : ""}>
          <Link to="/map">Mapa ofert</Link>
        </li>
        {/* End map menu item */}

        <li
          className={
            isActiveParent
              ? "menu-item-has-children -has-mega-menu current"
              : "menu-item-has-children -has-mega-menu"
          }
        >
          <Link to="/#inspire">
            <span className="mr-10">Zainspiruj się</span>
            <i className="icon icon-chevron-sm-down" />
          </Link>
          <div className="mega">
            <CategoriesMegaMenu setIsActiveParent={setIsActiveParent} />
          </div>
        </li>
        {/* End categories menu items */}

        <li className={pathname === "/destinations" ? "current" : ""}>
          {/*<Link to="/destinations">Destynacje</Link>*/}
        </li>
        {/* End Destinatinos single menu */}

        {/*<li*/}
        {/*  className={`${*/}
        {/*    isActiveParentChaild(blogItems, pathname) ? "current" : ""*/}
        {/*  } menu-item-has-children`}*/}
        {/*>*/}
        {/*  <a href="#">*/}
        {/*    <span className="mr-10">Blog</span>*/}
        {/*    <i className="icon icon-chevron-sm-down" />*/}
        {/*  </a>*/}
        {/*  <ul className="subnav">*/}
        {/*    {blogItems.map((menu, i) => (*/}
        {/*      <li*/}
        {/*        key={i}*/}
        {/*        className={*/}
        {/*          isActiveLink(menu.routePath, pathname) ? "current" : ""*/}
        {/*        }*/}
        {/*      >*/}
        {/*        <Link to={menu.routePath}>{menu.name}</Link>*/}
        {/*      </li>*/}
        {/*    ))}*/}
        {/*  </ul>*/}
        {/*</li>*/}
        {/* End blogIems */}

        {/*<li*/}
        {/*  className={`${*/}
        {/*    isActiveParentChaild(pageItems, pathname) ? "current" : ""*/}
        {/*  } menu-item-has-children`}*/}
        {/*>*/}
        {/*  <a href="#">*/}
        {/*    <span className="mr-10">Pages</span>*/}
        {/*    <i className="icon icon-chevron-sm-down" />*/}
        {/*  </a>*/}
        {/*  <ul className="subnav">*/}
        {/*    {pageItems.map((menu, i) => (*/}
        {/*      <li*/}
        {/*        key={i}*/}
        {/*        className={*/}
        {/*          isActiveLink(menu.routePath, pathname) ? "current" : ""*/}
        {/*        }*/}
        {/*      >*/}
        {/*        <Link to={menu.routePath}>{menu.name}</Link>*/}
        {/*      </li>*/}
        {/*    ))}*/}
        {/*  </ul>*/}
        {/*</li>*/}
        {/* End pages items */}

        {/*<li*/}
        {/*  className={`${*/}
        {/*    pathname.split("/")[1] == "dashboard" ||*/}
        {/*    pathname.split("/")[1] == "vendor-dashboard"*/}
        {/*      ? "current"*/}
        {/*      : ""*/}
        {/*  } menu-item-has-children`}*/}
        {/*>*/}
        {/*  <a href="#">*/}
        {/*    <span className="mr-10">Dashboard</span>*/}
        {/*    <i className="icon icon-chevron-sm-down" />*/}
        {/*  </a>*/}
        {/*  <ul className="subnav ">*/}
        {/*    {dashboardItems.map((menu, i) => (*/}
        {/*      <li*/}
        {/*        key={i}*/}
        {/*        className={*/}
        {/*          isActiveLink(menu.routePath, pathname) ? "current" : ""*/}
        {/*        }*/}
        {/*      >*/}
        {/*        <Link to={menu.routePath}>{menu.name}</Link>*/}
        {/*      </li>*/}
        {/*    ))}*/}
        {/*  </ul>*/}
        {/*</li>*/}
        <li className={pathname === "/contact" ? "current" : ""}>
          <Link to="/tour-list-v2">Ulubione</Link>
        </li>
        <li className={pathname === "/blog" || pathname.startsWith("/blog/") ? "current" : ""}>
          <Link to="/blog">Blog</Link>
        </li>
        <li className={pathname === "/contact" ? "current" : ""}>
          <Link to="/contact">Informacje</Link>
        </li>
      </ul>
    </nav>
  );
};

export default MainMenu;
